import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import { TOKEN_KEY } from '../../services/apiService'; 
function Navbar({ toggleSidebar }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
 
  useEffect(() => {
  const currentUser = authService.getCurrentUser();
  setUser(currentUser); 
}, []);
const handleLogout = async () => {
  try {
    await authService.logout();  
    setUser(null);
    navigate("/admin/login", { replace: true });
  } catch (error) {
    console.error("Logout failed:", error);
    alert("Logout failed. Please try again.");
  }
};
  return (
    <nav
      className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
      id="layout-navbar"
    >
      <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
        <button
          className="nav-item nav-link px-0 me-xl-4 btn btn-link"
          onClick={(e) => {
            e.preventDefault();
            toggleSidebar();
          }}
          aria-label="Toggle sidebar"
        >
          <i className="bx bx-menu bx-sm" />
        </button>
      </div>
      <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
        {/* <div className="navbar-nav align-items-center">
          <div className="nav-item d-flex align-items-center">
            <i className="bx bx-search fs-4 lh-0" />
            <input
              type="text"
              className="form-control border-0 shadow-none"
              placeholder="Search..."
              aria-label="Search"
            />
          </div>
        </div> */}
        <ul className="navbar-nav flex-row align-items-center ms-auto">
          <li className="nav-item dropdown-user" style={{ position: 'relative' }}>
            <button
              className="nav-link hide-arrow btn btn-link"
              onClick={(e) => {
                e.preventDefault();
                setIsDropdownOpen(!isDropdownOpen);
              }}
              aria-haspopup="true"
              aria-expanded={isDropdownOpen}
              aria-label="User menu"
              type="button"
            >
              <div className="avatar avatar-online">
                <img
                  src={user?.profile_image || '/assets/img/avatars/avatar1.jpg'}
                  alt="User"
                  className="w-px-40 h-auto rounded-circle img-fluid"
                />
              </div>
            </button>
            {isDropdownOpen && (
              <ul
                className="dropdown-menu dropdown-menu-end"
                style={{
                  display: 'block',
                  position: 'absolute',
                  right: 0,
                  top: '100%',
                  marginTop: '10px',
                  zIndex: 1050,
                  backgroundColor: '#fff',
                  boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                  borderRadius: '0.375rem',
                  minWidth: '200px',
                  padding: '0.5rem 0',
                  listStyle: 'none',
                }}
                role="menu"
                aria-label="User dropdown menu"
              >
              <li>
  <div
    style={{
      padding: "10px 16px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
    }}
  >
    <div
      className="avatar avatar-online"
      style={{
        flexShrink: 0,
      }}
    >
      <img
        src={user?.profile_image || "/assets/img/avatars/avatar1.jpg"}
        alt="User"
        className="w-px-40 h-auto rounded-circle img-fluid"
        style={{
          width: "40px",
          height: "40px",
          objectFit: "cover",
        }}
      />
    </div>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minWidth: 0,
      }}
    >
      <span
        className="fw-semibold"
        style={{
          fontSize: "15px",
          lineHeight: "20px",
          whiteSpace: "nowrap",
        }}
      >
        {user?.username || "Guest"}
      </span>

      <small
        className="text-muted"
        style={{
          fontSize: "13px",
          lineHeight: "18px",
        }}
      >
        {user?.user_role
          ? user.user_role.charAt(0).toUpperCase() +
            user.user_role.slice(1)
          : ""}
      </small>
    </div>
  </div>
</li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
              <li>
  <Link
    className="dropdown-item"
    to="/admin/profile"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "10px 16px",
    }}
  >
    <i
      className="bx bx-user"
      style={{
        width: "20px",
        minWidth: "20px",
        fontSize: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />
    <span
      style={{
        lineHeight: "20px",
      }}
    >
      My Profile
    </span>
  </Link>
</li>
                 {/* <li>
  <Link
    className="dropdown-item"
    to="/admin/setting-rule"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "10px 16px",
    }}
  >
    <i
      className="bx bx-cog"
      style={{
        width: "20px",
        minWidth: "20px",
        fontSize: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />

    <span
      style={{
        lineHeight: "20px",
      }}
    >
      Settings
    </span>
  </Link>
</li> */}
              <li>
  <Link
    className="dropdown-item"
    to="/admin/change-password"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "10px 16px",
    }}
  >
    <i
      className="bx bx-key"
      style={{
        width: "20px",
        minWidth: "20px",
        fontSize: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />
    <span
      style={{
        lineHeight: "20px",
      }}
    >
      Change Password
    </span>
  </Link>
</li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
              <li>
  <button
    className="dropdown-item"
    onClick={handleLogout}
    type="button"
    style={{
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "10px 16px",
      textAlign: "left",
      border: "none",
      background: "transparent",
      cursor: "pointer",
    }}
  >
    <i
      className="bx bx-power-off"
      style={{
        width: "20px",
        minWidth: "20px",
        fontSize: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />

    <span
      style={{
        lineHeight: "20px",
      }}
    >
      Log Out
    </span>
  </button>
</li>
              </ul>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
}
export default Navbar;